import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { Observable, of, distinctUntilChanged, filter, map } from 'rxjs';

import { AspectRatioString } from '@fcom/common';
import { CmsArticle, CmsImageData, CmsTaxonomy, CmsTaxonomyGeneral, CmsTeaser } from '@fcom/core-api';
import { isPresent, safeMap } from '@fcom/core/utils';
import { finShare } from '@fcom/rx';

@Component({
  selector: 'cms-text-with-side-image',
  styleUrls: ['./cms-text-with-side-image.component.scss'],
  templateUrl: './cms-text-with-side-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsTextWithSideImageComponent implements OnInit {
  @Input()
  content$: Observable<CmsArticle>;

  cmsTags$: Observable<Array<CmsTaxonomy | string>>;

  aspectRatio$: Observable<AspectRatioString> = of('16x9' as AspectRatioString);
  image$: Observable<CmsImageData>;
  isBlackFriday$: Observable<boolean>;
  link$: Observable<CmsTeaser>;
  noPadding$: Observable<boolean>;
  showSectionMarker$: Observable<boolean>;
  textContent$: Observable<CmsArticle>;

  public readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  ngOnInit(): void {
    this.textContent$ = this.content$.pipe(
      filter(isPresent),
      map(({ media: _, ...rest }: CmsArticle): CmsArticle => ({ ...rest, media: [] })),
      finShare()
    );
    this.image$ = this.content$.pipe(
      filter(isPresent),
      map(({ media = [] }: CmsArticle): CmsImageData => media?.[0] as CmsImageData),
      finShare()
    );
    this.link$ = this.content$.pipe(
      filter(isPresent),
      map(({ related = [] }: CmsArticle): CmsTeaser => related?.[0] as CmsTeaser),
      finShare()
    );
    this.cmsTags$ = this.content$.pipe(
      filter(isPresent),
      map((content: CmsArticle): CmsTaxonomy[] =>
        safeMap(content, (c: CmsArticle): CmsTaxonomy[] => c.subjectTaxonomyTags)
      ),
      distinctUntilChanged()
    );
    this.isBlackFriday$ = this.cmsTags$.pipe(map((a: string[]): boolean => a.includes(this.TAXONOMY.BLACK_FRIDAY)));
    this.noPadding$ = this.cmsTags$.pipe(map((a: string[]): boolean => a.includes(this.TAXONOMY.NO_PADDING)));
    this.showSectionMarker$ = this.cmsTags$.pipe(
      map((a: string[]): boolean => !a.includes(this.TAXONOMY.NO_SECTION_MARKER))
    );
  }
}
